import type { FormatDateOptions } from 'react-intl';

export const getFormattedDate = (
	dateInputString: string,
	formatDate: (
		value: Parameters<Intl.DateTimeFormat['format']>[0],
		options: FormatDateOptions,
	) => string,
	formatTime: (
		value: Parameters<Intl.DateTimeFormat['format']>[0],
		options: FormatDateOptions,
	) => string,
) => {
	const dateString = new Date(dateInputString);
	const formattedDate: string = formatDate(dateString, {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
	});

	const formattedTime: string = formatTime(dateString, {
		hour: 'numeric',
		minute: 'numeric',
		hour12: true,
	});

	return `${formattedDate} ${formattedTime.replace('AM', 'a.m.').replace('PM', 'p.m.')}`;
};
